// font-size tokens from master-design-system.json → typography.EPIC.font-size
// 2xs=10px  xs=12px  s=14px  m=16px  2m=18px  l=20px  xl=24px  2xl=30px  3xl=48px
export type SizeToken = "2xs" | "xs" | "s" | "m" | "2m" | "l" | "xl" | "2xl" | "3xl"

export const sizeTokenClasses: Record<SizeToken, string> = {
  "2xs": "text-2xs",  // 10px — custom in tailwind.config.js
  "xs":  "text-xs",   // 12px
  "s":   "text-sm",   // 14px
  "m":   "text-base", // 16px
  "2m":  "text-lg",   // 18px
  "l":   "text-xl",   // 20px
  "xl":  "text-2xl",  // 24px
  "2xl": "text-3xl",  // 30px
  "3xl": "text-5xl",  // 48px
}
